import React from 'react';
import './StreakDisplay.css';

export const StreakDisplay = ({ currentStreak, longestStreak, todayStudied }) => {
  return (
    <div className="streak-container">
      <div className="streak-current">
        <div className="streak-icon">
          {currentStreak > 0 ? '🔥' : '📚'}
        </div>
        <div className="streak-info">
          <div className="streak-number">{currentStreak}</div>
          <div className="streak-label">Day Streak</div>
        </div>
        {todayStudied && (
          <div className="streak-badge">✓ Studied Today</div>
        )}
      </div>
      {longestStreak > currentStreak && (
        <div className="streak-best">
          Best: {longestStreak} days 🏆
        </div>
      )}
    </div>
  );
};
